import viewports from './viewports.js';
import mergeThemes from './themes.js';
import mergePalettes from './palettes.js';
const fontBasePixels = 16;
export {
/**
 * Defines UDS system wide constants
 */
viewports,
/**
 * Theme utilities to be used in both frontend theme provider and backend theme builds
 */
mergeThemes,
/**
 * Palette utilities to be used for palette builds
 */
mergePalettes,
/**
 * Assumed default system font size for use as a default or in font size calculations
 */
fontBasePixels };